/**
 * MaioS 브랜드 워드마크 — 2톤 스타일.
 * M·S = 브랜드 다크그린(#3f7d39, 로고 배경/기둥), aio = 강조 그린(#82bd3e, 죽순).
 * "MaioS"를 로고 텍스트로 표기하는 모든 곳에서 이 컴포넌트를 사용해 일관성을 유지한다.
 * - variant="light": 어두운 배경(푸터 등)용 — M·S를 흰색으로.
 * - 크기·여백은 className으로 조정 (예: <Wordmark className="text-3xl mb-2" />).
 */
export const BRAND_DARK = '#3f7d39';
export const BRAND_ACCENT = '#82bd3e';

interface WordmarkProps {
  className?: string;
  variant?: 'default' | 'light';
}

export default function Wordmark({ className = '', variant = 'default' }: WordmarkProps) {
  const primary = variant === 'light' ? '#ffffff' : BRAND_DARK;
  return (
    <span className={`inline-block font-bold select-none tracking-tight ${className}`}>
      <span style={{ color: primary }}>M</span>
      <span style={{ color: BRAND_ACCENT }}>aio</span>
      <span style={{ color: primary }}>S</span>
    </span>
  );
}
